function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.351,9.15A9.729,9.729,0,0,1,18.7,22.221l2.971-8.588a9.171,9.171,0,0,0,.74-3.483,7.6,7.6,0,0,0-.065-1Zm-7.194.106c.586-.03,1.113-.092,1.113-.092a.4.4,0,0,0-.062-.8s-1.576.123-2.592.123c-.955,0-2.561-.123-2.561-.123a.4.4,0,0,0-.062.8s.5.063,1.02.093l1.516,4.151L11.4,19.79,7.857,9.255c.586-.03,1.114-.092,1.114-.092a.4.4,0,0,0-.063-.8s-1.575.123-2.592.123c-.184,0-.4,0-.627-.011A9.724,9.724,0,0,1,20.383,6.643c-.042,0-.082-.008-.125-.008a1.684,1.684,0,0,0-1.633,1.726,4.548,4.548,0,0,0,.955,2.281,5.119,5.119,0,0,1,.8,2.682,11.783,11.783,0,0,1-.74,3.143l-.97,3.241L15.156,9.255ZM13.816,23.542a9.77,9.77,0,0,1-2.747-.4l2.919-8.479,2.988,8.189a.809.809,0,0,0,.069.134,9.7,9.7,0,0,1-3.229.552ZM4.092,13.816a9.688,9.688,0,0,1,.843-3.959L9.573,22.568a9.725,9.725,0,0,1-5.481-8.752ZM13.816,3A10.816,10.816,0,1,0,24.633,13.816,10.829,10.829,0,0,0,13.816,3Z",
  transform: "translate(-3 -3)",
  fill: "#d6d6d6",
  fillRule: "evenodd"
});

var SvgWordpressAlt = function SvgWordpressAlt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.633,
    height: 21.633,
    viewBox: "0 0 21.633 21.633",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordpressAlt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wordpress-alt.425091cc.svg";
export { ForwardRef as ReactComponent };